import React from 'react';
import createReactClass from 'create-react-class';

const SetsResultsPlaceholder = createReactClass({
  render() {
    return (
      <a href="#"></a>
    );
  },
});

export default SetsResultsPlaceholder;



// WEBPACK FOOTER //
// ./app/javascript/views/Sets/components/SetsResultsPlaceholder.js